import { useRef, useState, useEffect } from 'react';
import { CANVAS_WIDTH, CANVAS_HEIGHT, DEVICE_PIXEL_RATIO } from '../game-engine/constants';

export const useCanvasSetup = (reservedRight = 0) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const updateCanvasSize = () => {
      if (canvasRef.current) {
        const canvas = canvasRef.current;
        const container = canvas.parentElement;

        if (container) {
          // Reserve horizontal space (e.g. the demo's ECONOMY panel) so the pin
          // field scales to the SAME width the Rive board is constrained to.
          // Without this the canvas uses the full viewport while the board is
          // shrunk by its `right:<panel>` container, so pins/bins spill past the
          // board onto the background.
          const width = window.innerWidth - reservedRight;
          const height = window.innerHeight;

          const scaleX = width / CANVAS_WIDTH;
          const scaleY = height / CANVAS_HEIGHT;
          const fitScale = Math.min(scaleX, scaleY);

          canvas.width = width * DEVICE_PIXEL_RATIO;
          canvas.height = height * DEVICE_PIXEL_RATIO;
          canvas.style.width = `${width}px`;
          canvas.style.height = `${height}px`;

          setScale(fitScale);
        }
      }
    };

    updateCanvasSize();
    window.addEventListener('resize', updateCanvasSize);

    return () => window.removeEventListener('resize', updateCanvasSize);
  }, [reservedRight]);

  return {
    canvasRef,
    scale,
    dimensions: { width: CANVAS_WIDTH, height: CANVAS_HEIGHT },
  };
};